import { StringStringKeyValuePairGraphType } from "../GraphQL.Default";

export const unique = <T>(values: T[]) => {
    if ('Set' in window && Array.from) {
        const set = new Set(values);
        return Array.from(set);
    }

    const dict: { [key: string]: boolean } = {};
    const result: T[] = [];
    for (const value of values) {
        const key = String(value);
        if (!dict[key]) {
            dict[key] = true;
            result.push(value);
        }
    }
    return result;
}

export function toDictionary(input: Array<StringStringKeyValuePairGraphType>): Record<string, string> {
    const entries: [string, string][] = (input ?? [])
        .map(pair => {
            const key = pair?.key ?? null;
            const value = pair?.value ?? null;
            return key && value ? [key, value] : null;
        })
        .filter((e): e is [string, string] => e !== null);

    return Object.fromEntries(entries);
}